export default __webpack_public_path__ + "static/media/kyubi.bb6a07af.png";